export const CAMPAIGNS_EN = {
    'nav.module.campaigns': 'Campaigns',
    // ── refusals ──
    'campaigns.refusal.not_found': 'This campaign is not in this workspace.',
    'campaigns.refusal.not_text': 'This field is text.',
    'campaigns.refusal.too_long': 'This is longer than {max} characters.',
    'campaigns.refusal.owner_module_required': 'Say which module runs this campaign.',
    'campaigns.refusal.owner_module': 'The module is named by its key.',
    'campaigns.refusal.owner_module_fixed': 'The module that runs a campaign is set when it is made.',
    'campaigns.refusal.name_required': 'Give the campaign a name.',
    'campaigns.refusal.channel_required': 'Choose the channel.',
    'campaigns.refusal.channel': 'Choose the channel from the list; «Other» is for what none of them names.',
    'campaigns.refusal.subject_ref': 'Choose what the campaign promotes from the list.',
    'campaigns.refusal.budget_amount': 'The budget is a number with at most two decimals, not negative.',
    'campaigns.refusal.budget_currency': 'Choose the currency from the list.',
    'campaigns.refusal.budget_currency_pair': 'A budget is written with its currency.',
    'campaigns.refusal.code': 'The code is letters, digits, _ and -, up to 64.',
    'campaigns.refusal.code_taken': 'Another campaign in this workspace has this code.',
    'campaigns.refusal.day': 'Write the date as a day of the calendar.',
    'campaigns.refusal.dates': 'A campaign ends on or after the day it starts.',
    'campaigns.refusal.status_new': 'A new campaign is planned or active.',
    'campaigns.refusal.status_route': 'The status is changed on its own, not with the other fields.',
    'campaigns.refusal.status_required': 'Choose the status.',
    'campaigns.refusal.status': 'The status is planned, active, paused or ended.',
    'campaigns.refusal.move': 'A campaign that is {from} does not become {to}.',
    'campaigns.refusal.stale': 'Someone changed this campaign since you opened it. Open it again to see their change.',
    'campaigns.refusal.version': 'The version is the one the campaign was read at.',
    'campaigns.refusal.limit': 'Ask for 1 to 500 rows.',
    'campaigns.refusal.page': 'Ask for page 1 or later.',
    'campaigns.refusal.size': 'Ask for 1 to {max} rows a page.',
    'campaigns.refusal.sort': 'This list cannot be sorted by that column.',
    // ── statuses, and what the change record keeps ──
    'campaigns.status.planned': 'Planned',
    'campaigns.status.active': 'Active',
    'campaigns.status.paused': 'Paused',
    'campaigns.status.ended': 'Ended',
    'change.field.campaign.owner_module': 'Run by module',
    'change.field.campaign.name': 'Campaign',
    'change.field.campaign.channel': 'Channel',
    'change.field.campaign.status': 'Status',
    'change.field.campaign.starts_on': 'Starts',
    'change.field.campaign.ends_on': 'Ends',
    'change.field.campaign.subject_ref': 'Promotes',
    'change.field.campaign.budget_amount': 'Budget',
    'change.field.campaign.budget_currency': 'Budget currency',
    'change.field.campaign.utm_source': 'Tracking source',
    'change.field.campaign.utm_medium': 'Tracking medium',
    'change.field.campaign.utm_campaign': 'Tracking campaign',
    'change.field.campaign.code': 'Code',
    'change.field.campaign.status_changed_at': 'Status changed',
    'change.field.campaign.status_changed_by': 'Status changed by',
    'change.field.campaign.created_by': 'Created by',
    // ── the list, the page and their forms ──
    'nav.campaigns.campaigns': 'Campaigns',
    'entity.campaigns.campaign': 'Campaign',
    'campaigns.campaigns.title': 'Campaigns',
    'campaigns.campaigns.lede': 'What the workspace runs to bring in customers, on which channel and when.',
    'campaigns.campaigns.empty': 'No campaign yet. Add the first thing the workspace runs to bring in customers.',
    'campaigns.campaign.title': 'Campaign',
    'campaigns.card.tracking': 'Tracking tags',
    'campaigns.card.tracking.empty': 'No tracking tags yet. Add them so the campaign\'s links are counted to it.',
    'campaigns.col.name': 'Campaign',
    'campaigns.col.code': 'Code',
    'campaigns.col.channel': 'Channel',
    'campaigns.col.period': 'Runs',
    'campaigns.col.period.template': '{starts_on~ends_on}',
    'campaigns.col.ends_on': 'Ends',
    'campaigns.col.budget_amount': 'Budget',
    'campaigns.col.budget_currency': 'Currency',
    'campaigns.col.status': 'Status',
    'campaigns.col.owner_module': 'Run by',
    'campaigns.col.id': 'Id',
    'campaigns.col.version': 'Version',
    'campaigns.col.utm_source': 'Source (utm_source)',
    'campaigns.col.utm_medium': 'Medium (utm_medium)',
    'campaigns.col.utm_campaign': 'Campaign (utm_campaign)',
    'campaigns.col.status_changed_at': 'In this status since',
    'campaigns.col.created_by': 'Created by',
    'campaigns.col.created_at': 'Created',
    'campaigns.field.name': 'Name',
    'campaigns.field.channel': 'Channel',
    'campaigns.field.starts_on': 'Starts',
    'campaigns.field.ends_on': 'Ends',
    'campaigns.field.ends_on.help': 'Leave empty while it has no end.',
    'campaigns.field.budget_amount': 'Budget (SAR)',
    'campaigns.field.code': 'Code',
    'campaigns.field.code.help': 'What a customer quotes so a lead is counted to this campaign.',
    'campaigns.field.utm_source': 'Source (utm_source)',
    'campaigns.field.utm_medium': 'Medium (utm_medium)',
    'campaigns.field.utm_campaign': 'Campaign (utm_campaign)',
    'campaigns.action.create': 'New campaign',
    'campaigns.action.start': 'Start',
    'campaigns.action.pause': 'Pause',
    'campaigns.action.resume': 'Resume',
    'campaigns.action.edit': 'Edit',
    'campaigns.action.utm': 'Tracking tags',
    'campaigns.action.end': 'End the campaign',
    'campaigns.owner_module.campaigns': 'Platform',
    'campaigns.owner_module.crm': 'Sales',
    'campaigns.channel.paid_ads': 'Paid ads',
    'campaigns.channel.social': 'Social media',
    'campaigns.channel.email': 'Email',
    'campaigns.channel.whatsapp': 'WhatsApp',
    'campaigns.channel.sms': 'Text messages',
    'campaigns.channel.event': 'Event or exhibition',
    'campaigns.channel.referral': 'Referral',
    'campaigns.channel.signage': 'Signage',
    'campaigns.channel.other': 'Other',
};
export const CAMPAIGNS_AR = {
    'nav.module.campaigns': 'الحملات',
    // ── refusals ──
    'campaigns.refusal.not_found': 'هذه الحملة ليست في مساحة العمل هذه.',
    'campaigns.refusal.not_text': 'هذا الحقل نص.',
    'campaigns.refusal.too_long': 'هذا أطول من {max} حرفاً.',
    'campaigns.refusal.owner_module_required': 'حدّد الوحدة التي تدير هذه الحملة.',
    'campaigns.refusal.owner_module': 'تُسمّى الوحدة بمفتاحها.',
    'campaigns.refusal.owner_module_fixed': 'الوحدة التي تدير الحملة تُحدَّد عند إنشائها.',
    'campaigns.refusal.name_required': 'سمِّ الحملة.',
    'campaigns.refusal.channel_required': 'اختر القناة.',
    'campaigns.refusal.channel': 'اختر القناة من القائمة؛ «أخرى» لما لا تسمّيه أيٌّ منها.',
    'campaigns.refusal.subject_ref': 'اختر ما تروّج له الحملة من القائمة.',
    'campaigns.refusal.budget_amount': 'الميزانية رقم بخانتين عشريتين على الأكثر، وليست سالبة.',
    'campaigns.refusal.budget_currency': 'اختر العملة من القائمة.',
    'campaigns.refusal.budget_currency_pair': 'تُكتب الميزانية مع عملتها.',
    'campaigns.refusal.code': 'الرمز حروف وأرقام و _ و -، حتى 64.',
    'campaigns.refusal.code_taken': 'لحملة أخرى في مساحة العمل هذا الرمز.',
    'campaigns.refusal.day': 'اكتب التاريخ يوماً من التقويم.',
    'campaigns.refusal.dates': 'تنتهي الحملة في يوم بدئها أو بعده.',
    'campaigns.refusal.status_new': 'الحملة الجديدة مخطَّطة أو نشطة.',
    'campaigns.refusal.status_route': 'تُغيَّر الحالة وحدها، لا مع بقية الحقول.',
    'campaigns.refusal.status_required': 'اختر الحالة.',
    'campaigns.refusal.status': 'الحالة مخطَّطة أو نشطة أو موقوفة أو منتهية.',
    'campaigns.refusal.move': 'الحملة {from} لا تصير {to}.',
    'campaigns.refusal.stale': 'غيّر أحدهم هذه الحملة بعد أن فتحتها. افتحها من جديد لترى تغييره.',
    'campaigns.refusal.version': 'الإصدار هو الذي قُرئت عليه الحملة.',
    'campaigns.refusal.limit': 'اطلب من 1 إلى 500 صف.',
    'campaigns.refusal.page': 'اطلب الصفحة 1 أو ما بعدها.',
    'campaigns.refusal.size': 'اطلب من 1 إلى {max} صفاً في الصفحة.',
    'campaigns.refusal.sort': 'لا تُرتَّب هذه القائمة بهذا العمود.',
    // ── statuses, and what the change record keeps ──
    'campaigns.status.planned': 'مخطَّطة',
    'campaigns.status.active': 'نشطة',
    'campaigns.status.paused': 'موقوفة',
    'campaigns.status.ended': 'منتهية',
    'change.field.campaign.owner_module': 'الوحدة المديرة',
    'change.field.campaign.name': 'الحملة',
    'change.field.campaign.channel': 'القناة',
    'change.field.campaign.status': 'الحالة',
    'change.field.campaign.starts_on': 'تبدأ',
    'change.field.campaign.ends_on': 'تنتهي',
    'change.field.campaign.subject_ref': 'تروّج لـ',
    'change.field.campaign.budget_amount': 'الميزانية',
    'change.field.campaign.budget_currency': 'عملة الميزانية',
    'change.field.campaign.utm_source': 'مصدر التتبّع',
    'change.field.campaign.utm_medium': 'وسيط التتبّع',
    'change.field.campaign.utm_campaign': 'حملة التتبّع',
    'change.field.campaign.code': 'الرمز',
    'change.field.campaign.status_changed_at': 'تغيّر الحالة',
    'change.field.campaign.status_changed_by': 'غيّر الحالة',
    'change.field.campaign.created_by': 'أنشأها',
    // ── the list, the page and their forms ──
    'nav.campaigns.campaigns': 'الحملات',
    'entity.campaigns.campaign': 'حملة',
    'campaigns.campaigns.title': 'الحملات',
    'campaigns.campaigns.lede': 'ما تديره مساحة العمل لجلب العملاء، وعلى أي قناة ومتى.',
    'campaigns.campaigns.empty': 'لا حملة بعد. أضف أول ما تديره مساحة العمل لجلب العملاء.',
    'campaigns.campaign.title': 'الحملة',
    'campaigns.card.tracking': 'روابط التتبّع',
    'campaigns.card.tracking.empty': 'لا روابط تتبّع بعد. أضفها لتُنسب روابط الحملة إليها.',
    'campaigns.col.name': 'الحملة',
    'campaigns.col.code': 'الرمز',
    'campaigns.col.channel': 'القناة',
    'campaigns.col.period': 'الفترة',
    'campaigns.col.period.template': '{starts_on~ends_on}',
    'campaigns.col.ends_on': 'تنتهي',
    'campaigns.col.budget_amount': 'الميزانية',
    'campaigns.col.budget_currency': 'العملة',
    'campaigns.col.status': 'الحالة',
    'campaigns.col.owner_module': 'تديرها',
    'campaigns.col.id': 'المعرّف',
    'campaigns.col.version': 'الإصدار',
    'campaigns.col.utm_source': 'المصدر (utm_source)',
    'campaigns.col.utm_medium': 'الوسيط (utm_medium)',
    'campaigns.col.utm_campaign': 'الحملة (utm_campaign)',
    'campaigns.col.status_changed_at': 'في هذه الحالة منذ',
    'campaigns.col.created_by': 'أنشأها',
    'campaigns.col.created_at': 'أُنشئت',
    'campaigns.field.name': 'الاسم',
    'campaigns.field.channel': 'القناة',
    'campaigns.field.starts_on': 'تبدأ',
    'campaigns.field.ends_on': 'تنتهي',
    'campaigns.field.ends_on.help': 'اتركه فارغاً ما دام لا نهاية لها.',
    'campaigns.field.budget_amount': 'الميزانية (ر.س)',
    'campaigns.field.code': 'الرمز',
    'campaigns.field.code.help': 'ما يذكره العميل لتُنسب إليها الفرصة.',
    'campaigns.field.utm_source': 'المصدر (utm_source)',
    'campaigns.field.utm_medium': 'الوسيط (utm_medium)',
    'campaigns.field.utm_campaign': 'الحملة (utm_campaign)',
    'campaigns.action.create': 'حملة جديدة',
    'campaigns.action.start': 'ابدأ',
    'campaigns.action.pause': 'أوقف مؤقتاً',
    'campaigns.action.resume': 'استأنف',
    'campaigns.action.edit': 'عدّل',
    'campaigns.action.utm': 'روابط التتبّع',
    'campaigns.action.end': 'أنهِ الحملة',
    'campaigns.owner_module.campaigns': 'المنصّة',
    'campaigns.owner_module.crm': 'المبيعات',
    'campaigns.channel.paid_ads': 'إعلانات مدفوعة',
    'campaigns.channel.social': 'تواصل اجتماعي',
    'campaigns.channel.email': 'بريد إلكتروني',
    'campaigns.channel.whatsapp': 'واتساب',
    'campaigns.channel.sms': 'رسائل نصية',
    'campaigns.channel.event': 'معرض أو فعالية',
    'campaigns.channel.referral': 'إحالة',
    'campaigns.channel.signage': 'لافتة',
    'campaigns.channel.other': 'أخرى',
};
//# sourceMappingURL=i18n-campaigns.js.map